<template>
  <v-container class="A4 mb-3" id="printMe">
    <v-col cols="12" sm="1" md="2" class="my-btn">
        <v-autocomplete
v-model="temp.customer_id"
          :items="customersList"
          chips
          clearable
          hide-details
          hide-selected
          item-text="name"
          item-value="id"
          label="选择户主"
          solo
          style="max-width: 600px;"
          @change="getCustomerById"
          :search-input.sync="searchInner"
        >
          <template v-slot:no-data>
            <v-list-item>
              <v-list-item-title>
                等待加载数据中
                <strong>九色鹿网络</strong>
              </v-list-item-title>
            </v-list-item>
          </template>
          <template v-slot:selection="{ attr, on, item, selected }">
            <v-chip
              v-bind="attr"
              :input-value="selected"
              color="blue-grey"
              class="white--text"
              v-on="on"
            >
              <span v-text="item.name"></span>
            </v-chip>
          </template>
           <template v-slot:item="{ item }">
            <v-list-item-content>
              <!-- <v-list-item-title v-text="item.name"></v-list-item-title> -->
              <v-list-item-title >{{ item.name }}</v-list-item-title>
              <!-- <v-list-item-subtitle v-text="item.symbol"></v-list-item-subtitle> -->
              <v-list-item-subtitle >{{ item.symbol }}</v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>
    <span v-html="styleText"></span>

    <v-row class="d-flex justify-end my-header">
      <v-btn @click="goBack" class="primary my-btn my-1">
        <i class="mdi mdi-arrow-left-bold"></i>返回
      </v-btn>
      <v-btn v-print="printObj" class="primary my-btn my-1 ml-1 mr-11">
        <i class="mdi mdi-printer"></i>打印
      </v-btn>
    </v-row>

    <h1 class="head-1" style="text-align:center;letter-spacing:10px">
      拆迁证明
    </h1>
    <v-row style="width:100%;display: inline-flex;margin-left:-5px !important;margin-top:60px">

      <p class="note-header " style="line-height:60px">
        <span style="padding-left:2em;"></span>
        截止
        <span class="data-text-date">{{ $moment(dt_now).format("YYYY") }}</span>年<span class="data-text-date">{{ $moment(dt_now).format("MM") }}</span>月<span class="data-text-date">{{ $moment(dt_now).format("DD") }}</span>日，
        经系统查询，魏塘街道<span class="data-text">{{customer.village}}</span>村（社区），户主<span class="data-text">{{customer.name}}</span>，相关人员
        <span class="data-text">{{customer.transition_user}}</span>，均已落实魏塘街道安置政策。
      </p>
      <v-row class="note-header indent">
        <span>本证明仅供参考，有效期30天。</span>
      </v-row>
      <br>
      <br>
      <v-row class="note-header indent" style="width:100%">
        <span style="width:100%;text-align:right;">嘉善县魏塘街道办事处征迁指挥部办公室</span>

      </v-row>
      <br>
      <br>
      <v-row class="note-header indent" style="width:100%">
        <span style="width:100%;text-align:right;">{{ $moment(dt_now).format("YYYY") }}年{{ $moment(dt_now).format("MM") }}月{{ $moment(dt_now).format("DD") }}日</span>

      </v-row>
    </v-row>
<br>
    <p style="text-align:center;">
            <span>X————————————————————————————————————————————X</span>
          </p>
          <br />

          <h1 class="head-1" style="text-align:center;letter-spacing:10px">
      拆迁证明
    </h1>
    <v-row style="width:100%;display: inline-flex;margin-left:-5px !important;margin-top:60px">

      <p class="note-header " style="line-height:60px">
        <span style="padding-left:2em;"></span>
        截止
        <span class="data-text-date">{{ $moment(dt_now).format("YYYY") }}</span>年<span class="data-text-date">{{ $moment(dt_now).format("MM") }}</span>月<span class="data-text-date">{{ $moment(dt_now).format("DD") }}</span>日，
        经系统查询，魏塘街道<span class="data-text">{{customer.village}}</span>村（社区），户主<span class="data-text">{{customer.name}}</span>，相关人员
        <span class="data-text">{{customer.transition_user}}</span>，均已落实魏塘街道安置政策。
      </p>
      <v-row class="note-header indent">
        <span>本证明仅供参考，有效期30天。</span>
      </v-row>
      <v-row class="note-header indent" style="width:100%">
        <span style="width:100%;text-align:right;">嘉善县魏塘街道办事处征迁指挥部办公室</span>

      </v-row>
      <v-row class="note-header indent" style="width:100%">
        <span style="width:100%;text-align:right;">{{ $moment(dt_now).format("YYYY") }}年{{ $moment(dt_now).format("MM") }}月{{ $moment(dt_now).format("DD") }}日</span>

      </v-row>
    </v-row>


  </v-container>
</template>

<script>
import {
  fetchCustomerList,fetchCustomer
} from "@/api/customers";

export default {
  name: "Homestead Print",
  components: {},

  filters: {},
  data() {
    return {
      searchInner:'',
      styleText: '<style type="text/css">\n' + '  @page { size: portrait; }\n' + '</style>',
      src: "hetong.png",
      seq: "",
      user_name: this.$store.getters.name,
      company: this.$store.getters.company,
      details: null,
      // population_price: 580,
      // property_price: 960,
      // extend20_price: 3510,
      // market_discount_price: 6110,
      // market_price: 6110,
      dt_now: "",
      printObj: {
        id: "printMe",
        popTitle: "good print",
        extraCss: "https://www.baidu.com",
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
      },
      sub_fee: 0,
      cssBackgroundImg: {
        backgroundImage: `url(${require("@/assets/background.jpg")})`
      },
      icons: {
        sub_bike: {
          status: false,
          icon: "mdi-checkbox-blank-circle-outline"
        },
        sub_car: {
          status: false,
          icon: "mdi-checkbox-blank-circle-outline"
        },
        bike: {
          status: false,
          icon: "mdi-checkbox-blank-circle-outline"
        },
        car: {
          status: false,
          icon: "mdi-checkbox-blank-circle-outline"
        }

      },
      customersList:[],
      temp: {
        customer_id: "",
      },
      customer:""
    }
  },

  computed: {
    isAdminRole() {
      if (this.$store.getters.roles.includes("admin")) {
        return true;
      } else {
        return false;
      }
    }
  },
  created() {
    // this.getBill(this.$route.params.id);

    // this.dt_now = Date.now();
    // this.seq = this.$route.params.seq;
    // console.log(this.$route.params.surplus)
    // this.surplus = this.numberToString(this.$route.params.seq);
    this.getCustomerList();
    this.dt_now = Date.now();
  },

  methods: {
    goBack() {
      console.log("goback clicked");
      this.$router.go(-1);
    },
    getCustomerById() {
      this.listLoading = true;
      fetchCustomer(this.temp.customer_id).then(response => {
        // console.log(response.data)
        this.customer = response.data;
        this.customer.village = this.customer.village.replace("村","")
        this.customer.village = this.customer.village.replace("社区","")
        console.log(this.customer)
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
    },

    getCustomerList(keyword){
      console.log(4444)
      const data = {
          customer_name:keyword
      }
      fetchCustomerList(data).then(response => {
        this.customersList = response.data.items;
        // Just to simulate the time of the request
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
      
    },
    handleInput(e) {
      console.log(e)
    },
  },
    watch: {
      searchInner (n, o) {
        // this.data.keyword = n
        console.log(this)
        this.getCustomerList(n)
        
        
      }
    }
};
</script>

<style scoped>
body {
  margin: auto;
  padding: auto;
  background: rgb(65, 63, 63);

}

.A4 {
  background: rgb(255, 253, 253);
  /* background-image: url(/../assets/hetong.png); */
  /* width: 21cm;
  height: 29.7cm; */
  width: 1000px;
  height: 1500px;
  display: block;
  /* box-shadow: 0 0 1px 1px rgb(2, 164, 252); */
  overflow-y: auto;
  box-sizing: border-box;
  margin: auto;
  font-family: serif;
  color: #000;
}

.head-1 {
  margin-top: 0;
  /* padding: 0 0 20px 0; */
  font-weight: 600;
  font-size: 36pt;
  text-align: center;
  width: 100%;
}

.input-text {
  font-weight: 600;
  font-size: 10pt;
  color: rgb(3, 54, 192);
}

.input-text-red {
  font-weight: 700;
  font-size: 10pt;
  color: rgb(231, 5, 5);
}

.money {
  text-align: left;
  font-weight: 600;
  color: rgb(3, 54, 192);
  padding: 0 0 0 20px;
}

td {
  padding-top: 9px;
  padding-bottom: 6px;
  padding-left: 8px;
  padding-right: 8px;
}

table {
  margin: auto;
  text-align: right;
}

.flex-container {
  display: flex;
  flex-wrap: wrap;
  font-size: 12px;
  justify-content: space-around;
}

.note-header {
  padding: 0px 100px 30px 80px;
  font-size: 25pt;
}

.indent {
  text-indent: 2em
}

.my-input150 {
  border: none;
  border-bottom: 1.5px solid #555555;
  width: 150px;
  text-align: center;
}

.line {
  line-height: 1.5;
}

.note-footer {
  padding: 20px 25px 10px 40px;
}

.data-text {
  border-bottom: 1.5px solid #555555;
  padding: 0 50px 0 50px;
}

.data-text-date {
  border-bottom: 1.5px solid #555555;
  padding: 0 10px 0 10px;
}


.my-input {
  margin: 0 35px 0 0;
}

.sanjiaoxing {
  width: 0;
  height: 0;
  border-color: transparent rgb(231, 93, 93);
  border-width: 0 0 120px 120px;
  border-style: solid;
  position: absolute;
}

.sequence {
  margin: 0 0 5px 10px;
  padding: 0 5px 0 5px;
  position: absolute;
  /* background-color: rgb(172, 104, 104); */
  transform: rotate(-45deg);
  transform-origin: 20% 40%;
}

.icon-check {
  color: #000 !important;
  margin-right: -5px;
  font-size: 12px !important;
  height: 0px;
  width: 25px;
}

.theme--dark .v-label {
  color: #000 !important;
}


@page {
  /* size: A4; */
  /* size: portrait; */
  margin: 0;
}

/* @media print{@page {size: landscape}} */

@media print {
  .A4 {
    background: white;
  }

  .head-2 {
    background-color: rgb(231, 229, 226);
  }

  .head-4 {
    background-color: rgb(231, 229, 226);
  }

  .my-header {
    height: 50px;
  }

  .my-btn {
    display: none;
  }

  .six_word {
    width: 120px;
  }

  .sanjiaoxing {
    display: none;
  }

  .sequence {
    display: none;
  }
}</style>
